import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    Award,
    BadgeCheck,
    BookOpen,
    ChartLine,
    Clapperboard,
    Globe,
    Handshake,
    History,
    Info,
    LayoutDashboard,
    MessageSquareWarning,
    Share2,
    TicketPercent,
    Users,
    Activity,
} from 'lucide-react';
import AppSidebar from '../layout/AppSidebar/AppSidebar';
import { ROLES, cabinetPath } from '../../roles/config';

const Navbar = () => {

    const navigate = useNavigate();
    const [studentAbout, setStudentAbout] = useState(false)
    const location = useLocation()
    const isIifaActive = ["/certificate", "/about", "/partners", "/social-media"].includes(location.pathname);
    const handleView = () => {
        setStudentAbout(x => !x)
    }

    const handleLogout = () => {
        localStorage.removeItem("admin_token");
        localStorage.removeItem("role");
        navigate("/login");
        window.location.reload();
    };

    // Bandlar, path'lar va matnlar avvalgidek; faqat guruhlarga ajratilgan.
    const groups = [
        {
            label: "Asosiy",
            items: [
                { to: "/", label: "Dashboard", icon: LayoutDashboard },
                { to: "/sales", label: "Sales", icon: ChartLine },
                { to: "/students", label: "Students", icon: Users },
                { to: "/learning-analytics", label: "Learning analytics", icon: Activity },
            ],
        },
        {
            label: "Ta'lim",
            items: [
                { to: "/courses", label: "Courses", icon: BookOpen },
                { to: "/certificate-holders", label: "Certificate holders", icon: Award },
                { to: "/promo-code", label: "Promo Code", icon: TicketPercent },
            ],
        },
        {
            label: "Video",
            items: [
                { to: "/new-lesson", label: "Video generate", icon: Clapperboard },
                { to: "/history", label: "Video generating history", icon: History },
            ],
        },
        {
            // Rollar kabinetlari: administrator uchun qo'shimcha sahifalar (src/roles/config.js)
            label: "Tizim",
            items: ROLES.admin.groups[0].items.map((item) => ({ to: cabinetPath('admin', item.key), label: item.label, icon: item.icon })),
        },
        {
            label: "IIFA UZ sayt",
            icon: Globe,
            collapsible: true,
            open: studentAbout,
            onToggle: handleView,
            active: isIifaActive,
            items: [
                { to: "/notifications/student-complaints" || "/notifications/teacher-complaints", label: "Complaints", icon: MessageSquareWarning, onClick: handleView },
                { to: "/about", label: "About", icon: Info, onClick: handleView },
                { to: "/partners", label: "Partners", icon: Handshake, onClick: handleView },
                { to: "/social-media", label: "Social Networks", icon: Share2, onClick: handleView },
                { to: "/certificate", label: "Certificate", icon: BadgeCheck, onClick: handleView },
            ],
        },
    ];

    return <AppSidebar groups={groups} onLogout={handleLogout} />;
}

export default Navbar;
